import { CenterEvent } from '../../lib/types/models/center-event/center-event'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AssignCenterEventRequest = {
  assignedToId: number
  centerEventId: number
}

export const assignCenterEvent = async (input: AssignCenterEventRequest): Promise<CenterEvent> => {
  const { assignedToId, centerEventId } = input
  return restApiClient
    .url(constructApiUrl(API.centerEvents.assign.url, { id: centerEventId }))
    .post<CenterEvent>({ assignedToId })
}
